import { AccordionItem } from "@att-bit/duc.components.accordion-item";
import { HeadingInterface, HeadingSizes } from "@att-bit/duc.components.heading";
import { LegalWrapperInterface } from "@att-bit/duc.components.legal-wrapper";
import { TextInterface } from "@att-bit/duc.components.text";
import { ComponentInterfaceBaseClass } from "@att-bit/duc.utils-ts.types";
import React from "react";
import { Accordion, AccordionProps } from ".";

export class AccordionInterface
  extends ComponentInterfaceBaseClass
  implements AccordionProps
{
  children;
  initialChildren?: any;
  withExpand?: boolean;
  title?: any;
  name: string;
  classNames: string;
  theme?: any;
  initialAccCount?: string;
  expandAllText?: string;
  collapseAllText?: string;
  compImpression?: any;
  containerId?: string;
  expandAccessibilityText?: string;
  collapseAccessibilityText?: string;
  viewMoreAccessibilityText?: string;
  viewLessAccessibilityText?: string;

  static initWithSanity(key, feed) {
    const t = new AccordionInterface();
    //const HtmlToReactParser = require("html-to-react").Parse 
    const initialChildrenArr = feed.accordioncontent.accordionItem.slice();
    if(initialChildrenArr.length > feed.accordioncontent?.initialCount) {      
      initialChildrenArr.splice(feed.accordioncontent?.initialCount, initialChildrenArr.length);
    }
    let tempCompImpression = feed.linkAnalyticsObj ? feed.linkAnalyticsObj : (feed.compImpression ? {...feed.compImpression, slotOrder: 1} : undefined);
    t.children = this.mapAccordionItems(feed.accordioncontent.accordionItem, feed.linkAnalyticsObj,tempCompImpression);
    t.initialChildren = this.mapAccordionItems(initialChildrenArr, feed.linkAnalyticsObj, tempCompImpression);
    t.withExpand = feed.accordioncontent.withExpand;
    t.title = feed.accordioncontent.heading && HeadingInterface.initWithSanity('heading', feed.accordioncontent.heading);
    t.name = Math.random().toString();
    t.classNames = feed.containerConfig?.containerClasses
      ? `${feed.containerConfig.containerClasses.join(" ")}`
      : null;
    t.theme = feed.containerConfig?.theme;
    t.initialAccCount = feed.accordioncontent?.initialCount;
    t.expandAllText = feed.accordioncontent?.expandAllText;
    t.expandAccessibilityText = feed.accordioncontent?.expandAccessibilityText;
    t.viewMoreAccessibilityText = feed.accordioncontent?.viewMoreAccessibilityText;
    t.viewLessAccessibilityText = feed.accordioncontent?.viewLessAccessibilityText;
    t.collapseAccessibilityText = feed.accordioncontent?.collapseAccessibilityText;
    t.collapseAllText = feed.accordioncontent?.collapseAllText;
    t.compImpression = tempCompImpression;
    t.containerId = feed?.accordioncontent?.containerId;
    return t;
  }
  static mapAccordionItems(accordionItem: any, linkObj: any, compImpression: any): any {
    return accordionItem.map((item, index) => {
      const title = item.title && HeadingInterface.initWithSanity('heading', item.title);
        const titleele = typeof item.title === "string" ? item.title : title?.toJsx({size: HeadingSizes.MD, margin: ["mar-b-none"]});
        //const htmlInput = item.body.text.replace("<ol>", "<ol class='mar-l-sm'>");
        const containsList = (item.body.text.includes("<ul><li>") || item.body.text.includes("<ol><li>"));
        const textInput = item.body && TextInterface.initWithSanity('body', {
          linkAnalyticsObj: linkObj,
          ...item.body
        });
        const legalkey =`legal_${compImpression && compImpression.componentOrder ?  compImpression.componentOrder : 1 }_${index}`
        const legalInput = item.legal && LegalWrapperInterface.initWithSanity(legalkey, {
          linkAnalyticsData: linkObj,
          ...item.legal
        });
        if(legalInput && legalInput.toProps() && legalInput.toProps().options) {
          legalInput.toProps().options.className = 'mar-t-sm-all mar-b-none';
        }
        //const htmlele = React.createElement("div", {"dangerouslySetInnerHTML": {__html: htmlInput}});
        const textele = textInput?.toJsx();
        const legalele = legalInput?.toJsx();
        /*const htmlToReactParser = new HtmlToReactParser();
        const reactElement = htmlToReactParser.parse(htmlInput);*/
        const itemProps = {
          isOpen: item.isOpen ? item.isOpen : false,
          children: "",
        };
        return React.createElement(AccordionItem, itemProps, [
          React.createElement(AccordionItem.Title, {}, titleele),
          React.createElement(AccordionItem.Body, {},
            React.createElement("div", {}, textele),
              React.createElement("div", {}, legalele))
        ]);
      });
  }

  toProps(): AccordionProps {
    const props = {
      children: this.children,
      withExpand: this.withExpand,
      title: this.title,
      name: this.name,
      classNames: this.classNames,
      theme: this.theme,
      initialAccCount: this.initialAccCount,
      expandAllText: this.expandAllText,
      expandAccessibilityText: this.expandAccessibilityText,
      viewMoreAccessibilityText: this.viewMoreAccessibilityText,
      viewLessAccessibilityText: this.viewLessAccessibilityText,
      collapseAccessibilityText: this.collapseAccessibilityText,
      collapseAllText: this.collapseAllText,
      initialChildren: this.initialChildren,
      compImpression: this.compImpression,
      suppressAnalytics: false,
      containerId: this.containerId
    };
    return props;
  }
  toJsx(): JSX.Element {
    return React.createElement(Accordion, {
      ...this.toProps(),
    });
  }
}
